/*
  Flooring Surgeons – mega menu + mobile drawer behaviour (like-for-like with the old flooringsurgeons.co.uk menu).
  Without this file everything still works: the menus are Dawn <details> (click / Enter / Esc / focus-out) and the
  drawer's category rail is CSS radio tabs. This only adds what the old site did with Preline:
    - desktop mouse: a panel opens the moment the pointer enters a category and closes the moment it leaves
      (the item includes the panel and its drop area), one panel at a time, no delays;
    - desktop mouse: clicking a category name goes to that category (old triggers were links);
    - drawer: the "×" closes the drawer, and Dawn's drawer script is kept away from the option accordions
      (it would otherwise treat them as slide-in submenus and trap focus inside them).
*/
(() => {
  const desktopMouse = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const menus = Array.from(document.querySelectorAll('details[data-fs-mega]'));

  const setOpen = (details, open) => {
    if (open === details.hasAttribute('open')) return;
    details.toggleAttribute('open', open);
    details.querySelector('summary')?.setAttribute('aria-expanded', String(open));
  };

  menus.forEach((details) => {
    const item = details.closest('li') || details;
    const summary = details.querySelector('summary');

    item.addEventListener('pointerenter', (event) => {
      if (event.pointerType !== 'mouse' || !desktopMouse.matches) return;
      menus.forEach((m) => m !== details && setOpen(m, false));
      setOpen(details, true);
    });

    item.addEventListener('pointerleave', (event) => {
      if (event.pointerType !== 'mouse' || !desktopMouse.matches) return;
      setOpen(details, false);
    });

    // Mouse click on the category name → the category page. Keyboard (Enter/Space, detail === 0) keeps toggling.
    summary?.addEventListener('click', (event) => {
      if (event.detail === 0 || !desktopMouse.matches || !summary.dataset.href) return;
      event.preventDefault();
      window.location.href = summary.dataset.href;
    });
  });

  // Mobile drawer
  const drawer = document.querySelector('header-drawer');
  const panel = drawer?.querySelector('.fs-dm');
  if (!drawer || !panel) return;
  const burger = drawer.querySelector('details > summary');

  const closeDrawer = (event) => {
    if (typeof drawer.closeMenuDrawer === 'function') drawer.closeMenuDrawer(event, burger);
    burger?.setAttribute('aria-expanded', 'false');
    burger?.focus();
  };

  // Capture phase on the panel: runs before Dawn's listeners on the summaries / buttons inside it.
  panel.addEventListener(
    'click',
    (event) => {
      if (event.target.closest('.fs-dm__close')) {
        event.stopPropagation();
        closeDrawer(event);
      } else if (event.target.closest('.fs-dm__acc > summary')) {
        event.stopPropagation(); // native <details> toggle only
      }
    },
    true
  );
  panel.addEventListener(
    'keyup',
    (event) => {
      if (event.code?.toUpperCase() !== 'ESCAPE') return;
      event.stopPropagation();
      closeDrawer(event);
    },
    true
  );
})();
